import types from '../types'

const initialState = {
  outbound: {
    fareClasses: [],
  },
  inbound: {
    fareClasses: [],
  },
}

const selectionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MODE_SELECTED:
      return changeCurrentModeId(state, action.payload)
    case types.MODE_INITIALIZED:
      return initMode(state, action.payload)
    case types.TICKET_CLEAR_RESULTS:
      return deselectItinerary(state, true)
    case types.OUTBOUND_FARE_CLASS_SELECTED:
      return fareClassChanged(state, action.payload, true)
    case types.INBOUND_FARE_CLASS_SELECTED:
      return fareClassChanged(state, action.payload, false)
    case types.RESPONSES_LOADING:
      return resetState(state)
    case types.FERRY_TYPE_CHANGE:
      return resetState(state)
    case types.MODE_CHANGED:
      return initialState
    default:
      return state
  }
}

const resetState = (state) => ({
  ...initialState,
  currentModeId: state.currentModeId,
})

const initMode = (state, modeId) => {
  return {
    ...state,
    currentModeId: convertToModeId(modeId),
  }
}

const changeCurrentModeId = (state, modeId) => {
  return {
    ...initialState,
    currentModeId: modeId,
  }
}

const deselectItinerary = (state, isOutbound) => {
  let outbound = { ...state.outbound }
  let inbound = { ...state.inbound }
  if (isOutbound) {
    // If you deselect an outbound, deselect everything
    outbound = {
      ...state.outbound,
      fareClasses: [],
    }
    inbound = {
      ...state.inbound,
      fareClasses: [],
    }
  } else {
    // If you deselct an inbound, deselect only the inbound
    inbound = {
      ...state.inbound,
      fareClasses: [],
    }
  }

  return {
    ...state,
    outbound,
    inbound,
  }
}

const fareClassChanged = (state, fareClassNames, isOutbound) => {
  let outbound = { ...state.outbound }
  let inbound = { ...state.inbound }

  if (isOutbound) {
    outbound = {
      ...state.outbound,
      fareClasses: fareClassNames,
    }
  } else {
    inbound = {
      ...state.inbound,
      fareClasses: fareClassNames,
    }
  }

  return {
    ...state,
    outbound,
    inbound,
  }
}

export default selectionsReducer
